module.exports = __webpack_public_path__ + "images/prospector-ad8fcb0f4704eeb046236052161ec92a.png";